import {customElement, bindable} from 'aurelia-framework';

@customElement('sio-info-pane')
export class InfoPane
{
    @bindable() heading;
    @bindable() footer;
}